import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { provideUseCaseCollection } from '@causality/angular';
import { Config } from '@formunauts/shared/data-access';
import { SelfCheckoutApiRepository } from './self-checkout-api-repository';
import { DonorDeviceSignalStore } from './self-checkout-donor-device-store.service';
import { SelfCheckoutRepository } from './self-checkout-repository';
import {
  SelfCheckoutUseCaseConfig,
  SelfCheckoutUseCases,
} from './self-checkout.use-case';

export function provideSelfCheckoutDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SelfCheckoutApiRepository,
    DonorDeviceSignalStore,
    {
      provide: SelfCheckoutRepository,
      useExisting: SelfCheckoutApiRepository,
    },
    {
      provide: SelfCheckoutUseCaseConfig,
      useFactory: (timeoutCfg = inject(Config.Timeout)) =>
        new SelfCheckoutUseCaseConfig({
          timeout: 10_000,
        }),
    },
    provideUseCaseCollection(
      SelfCheckoutUseCases,
      () => new SelfCheckoutUseCases(inject(SelfCheckoutRepository)),
    ),
  ]);
}
